export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "sign_out": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Se déconnecter"])}
      },
      "en": {
        "sign_out": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sign out"])}
      }
    }
  })
}
